
import Box from '@mui/material/Box';
import EDTypography from '../Typography/EDTypography';
import { IRapportTextBoxControl } from './RapportMallTypes';
import { SELECTED_SHADOW, getPositionStyle } from './RapportMallUtils';
import RapportTypography from './RapportTypography';
import { RapportKontrollEditPosition } from './RapportKontrollEditPosition';
import { RapportKontrollHeader } from './RapportKontrollHeader';
import { RapporteditorTextField } from '../Rapporteditor/RapporteditorTextField';

export interface IProps {
  ctrl: IRapportTextBoxControl;
  sx?: any;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onSelect?: (path: number[]) => void;
  onUpdate?: (updatedControl: IRapportTextBoxControl) => void;
  controlPath: number[];
  selected?: boolean;
  maxWidth: number;
  defaultHeight: number;
}

export const RapportTextBox: React.FC<IProps> = props => {
  const {
    ctrl,
    sx,
    onMouseEnter,
    onMouseLeave,
    selected,
    maxWidth,
    defaultHeight,
  } = props;
  const handleSelect = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    if (props.onSelect) {
      props.onSelect(props.controlPath);
    }
  };
  return (
    <Box
      sx={{
        background: 'white',
        boxShadow: selected ? SELECTED_SHADOW : undefined,
        border: '1px solid #aaa',
        boxSizing: 'border-box',
        padding: 0,
        ...getPositionStyle(
          ctrl,
          props.controlPath.length > 1,
          maxWidth,
          defaultHeight
        ),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        ...sx,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleSelect}
      data-control-path={props.controlPath.join('-')}
    >
      {ctrl.Caption && (
        <EDTypography
          variant="caption"
          fontSize={10}
          lineHeight={1}
          sx={{
            p: '2px 4px 0 4px',
            m: 0,
            minHeight: 13,
          }}
        >
          {ctrl.Caption}
        </EDTypography>
      )}
      <Box
        sx={{
          flex: 1,
          p: '0px 4px 2px 8px',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <RapportTypography lineHeight={ctrl.Height}>
          {ctrl.Text}
        </RapportTypography>
      </Box>
    </Box>
  );
};

export interface IRapportTextBoxEditProps {
  value: IRapportTextBoxControl;
  onChange: (ctrl: IRapportTextBoxControl) => void;
}

export const RapportTextBoxEdit: React.FC<IRapportTextBoxEditProps> = props => (
  <Box sx={{ mt: 2 }}>
    <Box sx={{ mb: 3 }}>
      <RapportKontrollHeader value={props.value} />
      <RapporteditorTextField
        label="Rubrik"
        field="Caption"
        value={props.value}
        onChange={props.onChange}
        allowModelSelect
      />
      <RapporteditorTextField
        label="Text"
        field="Text"
        value={props.value}
        onChange={props.onChange}
        allowModelSelect
      />
    </Box>
    <RapportKontrollEditPosition
      value={props.value}
      onChange={props.onChange}
    />
  </Box>
);
